
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/store-locator/pharmacist-owners",
      function () {
        return require("private-next-pages/store-locator/pharmacist-owners/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/store-locator/pharmacist-owners"])
      });
    }
  